import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { PageTransition } from "@/components/PageTransition";
import Blog from "@/pages/Blog";

export const Route = createFileRoute("/blog/")({
  component: BlogRoute,
});

function BlogRoute() {
  return (
    <PageTransition>
      <Suspense fallback={<div className="min-h-screen bg-background" />}>
        <Blog />
      </Suspense>
    </PageTransition>
  );
}
